export default __webpack_public_path__ + "static/media/spreeha.4816c922.png";